import FormComponent from '../utils/FormComponent';
import * as user from '../../model/user';
import * as usersApi from '../../api/users-api';
import * as blockUtils from '../../utils/BlockUtils';
import i18next from 'i18next';
import ModalDialog from '../utils/ModalDialog';
import Form from '../utils/Form';
import ErrorBox from '../utils/ErrorBox';
import {getErrorDescription} from '../../utils/view-utils';
import TextInput from '../utils/TextInput';
import SelectInput from '../utils/SelectInput';
import PropTypes from 'prop-types';
import React from 'react';

class RegisterNewUserForm extends FormComponent {
  constructor(props) {
    super(props);

    this.sendForm = this.sendForm.bind(this);
  }

  initialState() {
    return user.toUserObject({availableRoles: this.props.availableRoles});
  }

  sendForm() {
    const validEmail = this.validateEmail();

    if (validEmail === true) {
      usersApi.registerNewUser(this.state).then((response) => {
        blockUtils.unblockUI();
        if (response.type === 'NEW_USER_ERROR') {
          this.handleError(response.error);
        } else {
          window.showAlert(i18next.t('success'), i18next.t('users.successful_registration'));
          $(`#${this.props.dialogId}`).modal('hide');
        }
      });
      blockUtils.blockUI();
    }
  }

  validateEmail(email = this.state.email) {
    if (email) {
      this.setState({emailError: ''});
      return true;
    } else {
      this.setState({emailError: i18next.t('errors.is_required', {field: i18next.t('users.attrs.email')})});
      return false;
    }
  }

  handleError(error) {
    this.setState({
      error: error,
    });
  }

  mapAvailableRolesToObjects() {
    return this.state.availableRoles.map((role) => {
      return {'id': role, 'name': i18next.t([`users.roles.${role}`])};
    });
  }

  render() {
    const modalTitle = i18next.t('users.register_new_user');

    return (
      <ModalDialog modalTitle={modalTitle} dialogId={this.props.dialogId} onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow} onSubmit={this.sendForm}>

        <Form>
          <ErrorBox errorMessage={getErrorDescription(this.state.error)} />

          <TextInput
            fieldId="username"
            labelText={i18next.t('users.attrs.login')}
            onChange={this.onChange}
            value={this.state.username}
          />

          <TextInput
            fieldId="email"
            labelText={i18next.t('users.attrs.email')}
            isRequired={true}
            error={this.state.emailError}
            onChange={this.onChange}
            value={this.state.email}
          />

          <SelectInput
            fieldId="language"
            labelText={i18next.t('users.attrs.language')}
            selected={this.state.language}
            onChange={this.onChange}
            values={user.UserLanguages}
            isRequired={true}
          />

          {this.state.availableRoles.length !== 0 ?
          <SelectInput
            fieldId="role"
            labelText={i18next.t('users.attrs.role')}
            onChange={this.onChange}
            values={this.mapAvailableRolesToObjects()}
            selected={this.state.role}
            isRequired={true}
          /> : null}

        </Form>
      </ModalDialog>
    );
  }
}

RegisterNewUserForm.propTypes = {
  dialogId: PropTypes.string,
  presentedUser: PropTypes.object,
};

RegisterNewUserForm.defaultProps = {};

export default RegisterNewUserForm;
